import { DOWNLOAD_DEFAULT, DOWNLOAD_MAYBORN } from '../../data/download'
import { getRelation, mapRelations } from '../relation'

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

export const mapDownloads = mapRelations(DOWNLOAD_DEFAULT)

export const getDownload = getRelation(DOWNLOAD_DEFAULT)

export const mapDownloadsMayborn = mapRelations(DOWNLOAD_MAYBORN)
